import { FuseLoadable } from '@fuse';

export const AuthConfig = {

    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/conta/:acao/:id',
            component: FuseLoadable({
                loader: () => import('./Perfil/PerfilApp')
            })
        },
        {
            path: '/:organizacao/:empresa/conta/:acao/:id',
            component: FuseLoadable({
                loader: () => import('./Perfil/PerfilApp')
            })
        },
        {
            path: '/perfilgoogle',
            component: FuseLoadable({
                loader: () => import('./PerfilGoogle/PerfilGoogleApp')
            })
        }
    ]
};
